module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thick_heart_mask.41484065.png";